import artifact from '$houdini/artifacts/TeardownCreateInventory'
import { MutationStore } from '../runtime/stores/mutation'

export class TeardownCreateInventoryStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
